import { cn } from '@/lib/utils';
import type { AnalyticsHubTone } from './analytics-dashboard-types';

export function dashboardToneLabel(tone: AnalyticsHubTone) {
  if (tone === 'critical') return 'Критично';
  if (tone === 'warning') return 'Внимание';
  return 'Спокойно';
}

export function dashboardToneClasses(tone: AnalyticsHubTone) {
  if (tone === 'critical') {
    return {
      border: 'border-rose-700',
      text: 'text-rose-50',
      soft: 'border-transparent bg-rose-600 text-white',
      gradient: 'from-rose-700 via-rose-800 to-orange-800',
      bar: 'bg-rose-600',
      ring: 'ring-rose-700',
    };
  }
  if (tone === 'warning') {
    return {
      border: 'border-amber-700',
      text: 'text-amber-50',
      soft: 'border-transparent bg-amber-600 text-white',
      gradient: 'from-amber-700 via-amber-800 to-yellow-800',
      bar: 'bg-amber-600',
      ring: 'ring-amber-700',
    };
  }
  return {
    border: 'border-emerald-700',
    text: 'text-emerald-50',
    soft: 'border-transparent bg-emerald-600 text-white',
    gradient: 'from-emerald-700 via-emerald-800 to-sky-800',
    bar: 'bg-emerald-600',
    ring: 'ring-emerald-700',
  };
}

export function dashboardCardClassName(tone: AnalyticsHubTone, className?: string) {
  const t = dashboardToneClasses(tone);
  return cn(
    'overflow-hidden rounded-3xl border bg-gradient-to-br text-white shadow-sm',
    t.border,
    t.gradient,
    className,
  );
}

export function formatDashboardNumber(value: number) {
  return new Intl.NumberFormat('ru-RU').format(value || 0);
}
